export function transformValueToFullPercentage(value: number): number {
  const moreThanOne = value > 1;
  const pointer = moreThanOne ? 0 : 1;

  return Number(value.toFixed(pointer));
}
